/**
 * @fileoverview 403 Access Denied page.
 * Displayed when an authenticated user tries to access a route
 * they don't have the required role for.
 */

import React from 'react';
import { Link } from 'react-router-dom';

/**
 * AccessDenied page component.
 * Shows a permission error message with a link back to the dashboard.
 * Uses Seedling heading font (Playfair Display) via h1 styling.
 *
 * @returns {JSX.Element} The access denied page
 */
function AccessDenied() {
  return (
    <div className="access-denied-page">
      <div className="access-denied-card">
        <h1 className="access-denied-icon">403</h1>
        <h2 className="access-denied-title">Access Denied</h2>
        <p className="access-denied-text">
          You don&apos;t have permission to access this page.
          Contact your organization administrator if you believe this is an error.
        </p>
        <Link to="/" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default AccessDenied;
